import {IPackingTypeMySuffix} from 'src/app/shared/model//packing-type-my-suffix.model';

export interface ILoadingSubTypeDto {
    id?: number;
    name?: string;
    loadingTypeName?:string
    packingTypes?: IPackingTypeMySuffix[];
}

export class LoadingSubTypeDto implements ILoadingSubTypeDto {
    constructor(public id?: number, public name?: string, public packingTypes: IPackingTypeMySuffix[] = [],public loadingTypeName?:string) {}
}
